!function() {
  "use strict";
  function e(e) {
    for (var t = 1; t < arguments.length; t++) {
      var o = arguments[t];
      for (var n in o) e[n] = o[n];
    }
    return e;
  }
  var t = function t(o, n) {
    function i(t, i, r) {
      if ("undefined" != typeof document) {
        "number" == typeof (r = e({}, n, r)).expires && (r.expires = new Date(Date.now() + 864e5 * r.expires)), 
        r.expires && (r.expires = r.expires.toUTCString()), t = encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var c = "";
        for (var s in r) r[s] && (c += "; " + s, !0 !== r[s] && (c += "=" + r[s].split(";")[0]));
        return document.cookie = t + "=" + o.write(i, t) + c;
      }
    }
    return Object.create({
      set: i,
      get: function(e) {
        if ("undefined" != typeof document && (!arguments.length || e)) {
          for (var t = document.cookie ? document.cookie.split("; ") : [], n = {}, i = 0; i < t.length; i++) {
            var r = t[i].split("="), c = r.slice(1).join("=");
            try {
              var s = decodeURIComponent(r[0]);
              if (n[s] = o.read(c, s), e === s) break;
            } catch (e) {}
          }
          return e ? n[e] : n;
        }
      },
      remove: function(t, o) {
        i(t, "", e({}, o, {
          expires: -1
        }));
      },
      withAttributes: function(o) {
        return t(this.converter, e({}, this.attributes, o));
      },
      withConverter: function(o) {
        return t(e({}, this.converter, o), this.attributes);
      }
    }, {
      attributes: {
        value: Object.freeze(n)
      },
      converter: {
        value: Object.freeze(o)
      }
    });
  }({
    read: function(e) {
      return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(e) {
      return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
  }, {
    path: "/"
  });
  window.Geo = new class {
    cookie=!1;
    domain=location.host.includes("schoffelcountry.com") ? ".schoffelcountry.com" : location.host;
    setGeolocationCookie(e) {
      t.set("geolocation", JSON.stringify(e), {
        expires: 30,
        domain: this.domain
      });
    }
    getGeolocationCookie() {
      try {
        return JSON.parse(t.get("geolocation"));
      } catch (e) {
        return !1;
      }
    }
    async getLocation(e = !1) {
      fetch(Shopify.routes.root + "browsing_context_suggestions.json").then((e => e.json())).then((t => {
        this.setGeolocationCookie(t.detected_values.country), e && e(t.detected_values.country);
      })).catch((e => {
        console.warn(e);
      }));
    }
    perform(e = !1) {
      this.cookie = this.getGeolocationCookie(), this.cookie && this.cookie.hasOwnProperty("handle") ? e && e(this.cookie) : this.getLocation(e);
    }
    constructor() {
      window.Geo = this;
    }
  }, new class {
    loading=[];
    header=document.querySelector("header");
    async importScript(e) {
      const t = e.tagName.toLowerCase(), o = "127.0.0.1" === location.hostname || Shopify && Shopify.theme && -1 !== Shopify.theme.name.indexOf("Development") || Shopify.designMode;
      if (-1 === this.loading.indexOf(t) && (this.loading.push(t), !customElements.get(t))) {
        var n = document.createElement("script");
        n.src = `${window.settings.asset_url || "/assets/"}${t}.js?v=${o ? Date.now() : window.settings.asset_revision || Date.now()}`, 
        n.async = !0, o && (n.onload = () => console.info(`Loaded: ${t}`)), n.onerror = () => console.warn(`Failed to load ${t}.`) && this.loading.splice(this.loading.indexOf(t)), 
        document.body.appendChild(n);
      }
    }
    loadScript(e) {
      e.hasAttribute("data-autoload") ? this.importScript(e) : new IntersectionObserver((async (t, o) => {
        t.forEach((async t => {
          t.isIntersecting && (this.importScript(e), o.disconnect());
        }));
      }), {
        rootMargin: "0px 0px 200% 0px"
      }).observe(e);
    }
    initJavascript() {
      document.querySelectorAll("[data-async]").forEach((e => this.loadScript(e))), new MutationObserver(((e, t) => {
        e.forEach((e => {
          e.target.querySelectorAll("[data-async]").forEach((e => this.loadScript(e)));
        }));
      })).observe(document.querySelector("body"), {
        childList: !0,
        subtree: !0,
        characterData: !1,
        attributes: !1
      });
    }
    initCloser() {
      window.addEventListener("keydown", (e => {
        "Escape" === e.key && (document.querySelectorAll("[data-locker]").forEach((e => e.checked = !1)), 
        document.body.classList.remove("overflow-hidden"));
      }));
    }
    scrollLock() {
      setTimeout((() => document.querySelectorAll("[data-locker]:checked").length ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden")), 100);
    }
    initScrollLock() {
      window.addEventListener("click", (e => {
        e.target.closest("teleport-details") || Shopify.debounce(this.scrollLock());
      }));
    }
    initClicks() {
      window.addEventListener("click", (e => {
        if (e.target) switch (e.target.tagName?.toUpperCase()) {
         case "LABEL":
          (t = e.target.querySelector("input") || document.getElementById(e.target.getAttribute("for"))) && -1 === t.name.toLowerCase().indexOf("filter") && t.classList.contains("hidden") && (e.preventDefault(), 
          e.stopPropagation(), t.checked = !t.checked, e.target.dispatchEvent(new Event("input", {
            bubbles: !0
          })), Shopify.debounce(this.scrollLock()));
          break;

         case "INPUT":
          "Search" == e.target.id && e.target.checked && (e.target.checked = !1);
          break;

         case "BUTTON":
         case "A":
          if (e.target.getAttribute("href")?.match(/\/cart$/) && !e.target.closest("shopping-cart")) e.preventDefault(), 
          document.querySelector("#Cart").checked = !document.querySelector("#Cart").checked; else {
            if (e.target.getAttribute("href")?.toLowerCase().includes("#accessibility") || e.target.getAttribute("href")?.toLowerCase().includes("#a11y")) return e.preventDefault(), 
            window.interdeal.a11y.openMenu(), !1;
            var t;
            e.target.getAttribute("href")?.match(/^#/) && "#" !== e.target.getAttribute("href") && (t = document.querySelector(e.target.getAttribute("href"))) && (e.preventDefault(), 
            window.scrollTo({
              top: t.offsetTop - this.header?.clientHeight,
              left: 0,
              behavior: "smooth"
            }));
          }
        }
      }));
    }
    trackRecentlyViewed() {
      Shopify = Shopify || {}, Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
      const e = location.href.match("/products/([^?#]+)");
      if (e) {
        const t = Shopify.recentlyViewed.indexOf(e[1]);
        t > -1 && Shopify.recentlyViewed.splice(t, 1), Shopify.recentlyViewed.unshift(e[1]), 
        Shopify.recentlyViewed = Shopify.recentlyViewed.slice(0, 8), localStorage.setItem("recentlyViewed", JSON.stringify(Shopify.recentlyViewed));
      }
    }
    visualViewport() {
      const e = document.querySelector("[data-announcement]"), t = Math.round(e?.clientHeight ?? 0), o = e?.getBoundingClientRect();
      let n = 0;
      o && o.bottom > 0 && (n = Math.max(0, Math.min(t, o.bottom))), document.documentElement.style.setProperty("--visual-viewport", `${window.visualViewport.height}px`), 
      document.documentElement.style.setProperty("--header-height", document.querySelector("header")?.clientHeight - 1 + "px"), 
      document.documentElement.style.setProperty("--header-height-full", `${Array.from(document.querySelectorAll(".shopify-section-group-header-group")).reduce(((e, t) => e + t.clientHeight), 0)}px`), 
      document.documentElement.style.setProperty("--announcement-height", `${document.querySelector("[data-announcement]")?.clientHeight}px`), 
      document.documentElement.style.setProperty("--dynamic-header-height-full", `${Math.round((document.querySelector("header")?.clientHeight - 1 || 0) + n)}px`);
    }
    scrollTrigger() {
      const e = document.querySelector("[data-announcement");
      e && new IntersectionObserver((e => {
        e[0].isIntersecting ? document.body.classList.remove("is-scrolled") : document.body.classList.add("is-scrolled");
      })).observe(e);
    }
    checkLocation() {
      sessionStorage.getItem("geolocation") || window.Geo.perform((e => {
        if (e.handle !== window.Shopify.country) {
          const t = document.getElementById("Location");
          if (!t) return;
          const o = t.nextElementSibling;
          o.querySelector('[name="country_code"]').value = e.handle, o.querySelectorAll("div").forEach((t => t.textContent.replaceAll("[detected]", e.name))), 
          t.checked = !0, sessionStorage.setItem("geolocation", !0);
        }
      }));
    }
    constructor() {
      this.initJavascript(), this.initCloser(), this.initScrollLock(), this.checkLocation(), 
      this.initClicks(), this.scrollTrigger(), this.trackRecentlyViewed(), this.visualViewport(), 
      document.addEventListener("DOMContentLoaded", (() => {
        this.visualViewport(), (window.visualViewport || window).addEventListener("resize", Shopify.debounce(this.visualViewport), {
          passive: !0
        });
      })), window.addEventListener("scroll", Shopify.debounce(this.visualViewport, 10), {
        passive: !0
      }), window.addEventListener("load", (() => {
        const e = window.location.href;
        if (e.includes("form_type=customer")) {
          var t = (t = e.split("#")).length > 1 ? t[t.length - 1] : "footer", o = document.querySelector(`#${t}`) || document.querySelector('footer[action^="/contact"]');
          if (o) {
            const e = o.querySelector('[type="email"]');
            if (e && e.value.length > 0) {
              const e = document.createElement("p");
              e.classList.add("mt-sm"), e.innerText = window.strings.existing, o.appendChild(e), 
              window.dataLayer = window.dataLayer || [], window.dataLayer.push({
                event: "newsletter_signup",
                form_action: "submit-failure",
                error_id: window.strings.existing
              });
            }
          }
        }
      }));
    }
  };
}();